import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Experimenting with the new React Concurrent mode",
  "description": "",
  "published": "2019-11-06T00:00:00.000Z",
  "redirect_from": ["/blog/experimenting-with-the-new-react-concurrent-mode/swizec/9231"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "./img/techletter.app-screenshot-1573060452637.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I've been playing around with React's new `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/concurrent-mode-intro.html"
      }}>{`Concurrent Mode`}</a>{` and it is amazing. A little mind-bendy, a dash mad, and a whole lot of wonderful.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/dark-waterfall-uzlzb"
      }}><img parentName="a" {...{
          "src": "/34eab03e89ebccbfd5f8cf3c7907291f/FznpjtC.gif",
          "alt": null
        }}></img></a></p>
    <p>{`Your app might get faster even if you don't change anything. 👌`}</p>
    <p>{`That's because concurrent mode is backwards compatible. Your code works the same ... if you've been following React best practices. If you haven't, god help you.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=NngI9tZz48E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20102v88l3-1%204-1%203-1-3-1-3-2-1-3v-4l2-3c-2-2%202-12%204-12h14l-1%2028-2-1c-2-1-4-1-4%201l1%201c3%200%204%202%203%208-1%207-2%207-8%206-3%200-5-1-8-4l-4-3v27h401v-14c0-8%200-13-1-11%200%202-1%203-3%203l-2-1-21-1-21-1h42v-11l-22-1h-22v7c0%206%200%206-3%208h-28l-25%201-1%205-1%205-1-1v-10h-53v-34H113v8l-19%203-22%205c-7%201-5-4%202-6l6-1-4-1c-5-1%209-4%2018-3l7-1c-1-1-9-2-14-1-14%203-20%204-22%202-2-1-2-2-1-2v-1l-2-1h-1l2-2c2%200%202%200%201-1v-2l-1-2c-1-1%202-1%209-1l25-1h15v2l1%203h129v-6H126V38h116V15H136L15%2014H0v88m195%203c-5%200-6%202-6%208%200%204%200%205%202%206h18v-13c-2-1-11-2-14-1m156%2047v3h44v-6h-44v3m0%2020v15h44v-10l-1-11v-1l1-5v-4h-44v16m-299-1c-7%201-13%208-10%2011l2%202h4c6-1%2011%207%207%2011v1h3l1%201c2-1%204%204%204%207l-4%201c-2%200-3%200-2%201l3%201c4%200%202%203-3%203-2%200-2%200%200%201%207%203%209-2%209-16%201-11-1-13-5-8l-3%201c0-1%204-6%206-5%202%200%201-3-1-7-3-4-7-6-11-5m61%2022c0%2012%200%2014%202%2014l1%201%204%201%205%201c2%201%202%200%202-12v-12l-6-3-7-3-1%2013\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/06d68f94191de29712f1d50d0061dbf6/ca0a1/techletter.app-screenshot-1573060452637.webp 223w", "/static/06d68f94191de29712f1d50d0061dbf6/75680/techletter.app-screenshot-1573060452637.webp 445w", "/static/06d68f94191de29712f1d50d0061dbf6/0ba47/techletter.app-screenshot-1573060452637.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/06d68f94191de29712f1d50d0061dbf6/e92b6/techletter.app-screenshot-1573060452637.png 223w", "/static/06d68f94191de29712f1d50d0061dbf6/e66bf/techletter.app-screenshot-1573060452637.png 445w", "/static/06d68f94191de29712f1d50d0061dbf6/6af66/techletter.app-screenshot-1573060452637.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/06d68f94191de29712f1d50d0061dbf6/6af66/techletter.app-screenshot-1573060452637.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "so-what-is-concurrent-mode"
    }}>{`So what `}<em parentName="h2">{`is`}</em>{` concurrent mode?`}</h2>
    <p>{`It's a change in how React schedules updates to your UI.`}</p>
    <blockquote>
      <p parentName="blockquote">{`/../ UI libraries, including React, typically work today. Once they start rendering an update, including creating new DOM nodes and running the code inside components, they can’t interrupt this work. We’ll call this approach “blocking rendering”. In Concurrent Mode, rendering is not blocking. `}<strong parentName="p">{`It is interruptible`}</strong>{`. This improves the user experience. It also unlocks new features that weren’t possible before.`}</p>
    </blockquote>
    <p>{`What this means is that you can start new UI updates `}<em parentName="p">{`before the old ones finish`}</em>{`.`}</p>
    <p>{`Say you're building a dataviz with streaming data. You're 5,000 elements in so adding another 1,000 takes a while. You start rendering and a new batch shows up before you're done.`}</p>
    <p>{`Now what?`}</p>
    <p>{`With blocking renders you have to wait.`}</p>
    <p>{`With concurrent mode you stop the current render and schedule a new one. 👌`}</p>
    <p>{`It's similar to how D3 transitions always let you schedule a new transition without worry. Each new transition first stops whatever's going on, then starts the new transition from current state.`}</p>
    <p>{`Try clicking this ball real fast to see what I mean`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/p789r1928x"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98M3%20140v2h51v-5H3v3m-1%2043v9h6c5-1%205-1%205%201s1%202%205%202h5v-9l-1-9-2-1c0-2-2-2-9-2H2v9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4399063181c4c577bf5e99501622c18d/ca0a1/techletter.app-screenshot-1573060471320.webp 223w", "/static/4399063181c4c577bf5e99501622c18d/75680/techletter.app-screenshot-1573060471320.webp 445w", "/static/4399063181c4c577bf5e99501622c18d/0ba47/techletter.app-screenshot-1573060471320.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4399063181c4c577bf5e99501622c18d/e92b6/techletter.app-screenshot-1573060471320.png 223w", "/static/4399063181c4c577bf5e99501622c18d/e66bf/techletter.app-screenshot-1573060471320.png 445w", "/static/4399063181c4c577bf5e99501622c18d/6af66/techletter.app-screenshot-1573060471320.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4399063181c4c577bf5e99501622c18d/6af66/techletter.app-screenshot-1573060471320.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Not quite concurrent mode but a similar idea.`}</p>
    <h2 {...{
      "id": "ok-so-what"
    }}>{`Ok so what?`}</h2>
    <p>{`So what!? This is amazing. This is what we've been waiting for for 2 years my friend.`}</p>
    <p>{`Not only is concurrent mode a big step forward for React itself, it also gives us some new abilities. The community is still figuring out the details, but what I've seen buzzing on twitter looks exciting.`}</p>
    <p>{`My favorite new ability is `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/concurrent-mode-suspense.html"
      }}>{`React Suspense`}</a>{` for data fetching. Dan just published an example where he loads code for the page `}<em parentName="p">{`at the same time as its data`}</em>{`. And then concurrent mode figures out the rest.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/dan_abramov/status/1191569529471549440"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "104.93273542600899%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'420\\'%20viewBox=\\'0%200%20400%20420\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-12%207-8%2026%206%2028%2012%201%2021-12%2015-22-4-8-14-10-21-6m31%2045v7h3c4%200%206-2%205-5v-5c0-2-1-3-4-3h-4v6m286%20192v3h-15v7h15v32a273%20273%200%20002%2029c0-1%200-2%205-2%206%200%207-1%206-5-1-2-2-2-6-2-5%200-5-1-5-2%200-2%200-2%205-2h6v-4l-1-4h-6c-4%200-4-1-4-2%200-2%200-2%205-2h6v-8h-6l-5%201v-21l-1-21-1%203m-115%2029h-1l-2%201-1%202-1-1c1-1-1-1-5-1-5%200-6%200-6%203l2%202v-2c0-1%200-2%201-1h1l1%201%201%201h1l13%201h14v-3c1-3%200-3-1-2h-3c-8-1-9%200-9%201%200%202%200%202-1%201h-3c-1-1%200-2%201-3v-1l-2%201m105%2013l-20%201-21%201%2020%201%2021%201h4c4-2%204-3%200-4-4-2-4-2-4%200m0%2011l-20%201-20%201c-1%201%206%201%2019%201l21%201c0%202%200%202%204%200l3-2-3-2c-4-2-4-2-4%200m-138%2058c-7%203-5%2014%203%2014%207%200%2010-8%206-12-3-3-5-3-9-2m16%201c-7%208%204%2018%2011%2010%202-2%202-3%202-5-2-7-8-9-13-5m22-1l-1%201c-2-1-6%203-4%204v2c-1%202%201%205%203%205%201-1%202%200%203%201%201%202%203%201%203-2%200-2-1-3-2-3v-2c1-1%203%200%202%201l1%201h2v2c1%200%202-3%201-4l-1-3c0-3-7-5-7-3m14%202c-3%203-3%206%201%2010%206%206%2015-3%2010-10l-3-2h-1c-2-1-4-1-7%202m20-2c-7%204-4%2014%204%2014%206%200%209-9%205-12-2-3-3-2-3%200l-1%202v-2c0-3-1-3-5-2m73%200c-3%202-5%209-2%2011%203%203%207%203%2010%201%207-5%200-16-8-12m-13%203l-5%202c-4%201-5%204-1%207%206%205%2016-4%2010-9-2-2-3-2-4%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9c1e73b34c51489c246f979203d0c9fb/ca0a1/techletter.app-screenshot-1573060441033.webp 223w", "/static/9c1e73b34c51489c246f979203d0c9fb/75680/techletter.app-screenshot-1573060441033.webp 445w", "/static/9c1e73b34c51489c246f979203d0c9fb/0ba47/techletter.app-screenshot-1573060441033.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9c1e73b34c51489c246f979203d0c9fb/e92b6/techletter.app-screenshot-1573060441033.png 223w", "/static/9c1e73b34c51489c246f979203d0c9fb/e66bf/techletter.app-screenshot-1573060441033.png 445w", "/static/9c1e73b34c51489c246f979203d0c9fb/6af66/techletter.app-screenshot-1573060441033.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9c1e73b34c51489c246f979203d0c9fb/6af66/techletter.app-screenshot-1573060441033.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><img parentName="p" {...{
        "src": "/8ea40ab6c639c0257ed3d7ee0f1d47e6/media-26ufdipQqU2lhNA4g-giphy.gif",
        "alt": "mind_blown giphy"
      }}></img></p>
    <p>{`Various react routes will have to implement this to work properly. You can't quite do it unless you know what data you'll need `}<em parentName="p">{`before`}</em>{` your components render.`}</p>
    <p>{`That's the biggest shift in mindset: Fetch data before/while rendering. Not `}<em parentName="p">{`after`}</em>{` initial render like we used to:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20this%20is%20the%20old%20fetch-on-render%20pattern%0Afunction%20MyComponent()%20%7B%0A%09const%20%5Bloading%2C%20setLoading%5D%20%3D%20useState(true)%3B%0A%09const%20%5Bdata%2C%20setData%5D%20%3D%20useState(null)%0A%09%0A%09useEffect(()%20%3D%3E%20%7B%0A%09%09%2F%2F%20run%20effect%20to%20load%20data%20when%20component%20first%20renders%0A%09%09fetchData().then(data%20%3D%3E%20%7B%0A%09%09%09setData(data)%0A%09%09%09setLoading(false)%0A%09%09%7D)%0A%09%7D%2C%20%5B%5D)%0A%09%0A%09if%20(loading)%20%7B%0A%09%09return%20%3CSpinner%20%2F%3E%0A%09%7Delse%7B%0A%09%09return%20%3CShowData%20data%3D%7Bdata%7D%20%2F%3E%0A%09%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "606px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "84.30493273542601%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'337\\'%20viewBox=\\'0%200%20400%20337\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2034a7811%207811%200%20001%20271c1%201%2030%202%20177%202s176-1%20177-2c2-1%202-12%202-136l-1-135c-1-3-355-3-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4ab78bdf5baf9671cd91e7c0041ddefb/ca0a1/techletter.app-screenshot-1573060439503.webp 223w", "/static/4ab78bdf5baf9671cd91e7c0041ddefb/75680/techletter.app-screenshot-1573060439503.webp 445w", "/static/4ab78bdf5baf9671cd91e7c0041ddefb/18e7e/techletter.app-screenshot-1573060439503.webp 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4ab78bdf5baf9671cd91e7c0041ddefb/e92b6/techletter.app-screenshot-1573060439503.png 223w", "/static/4ab78bdf5baf9671cd91e7c0041ddefb/e66bf/techletter.app-screenshot-1573060439503.png 445w", "/static/4ab78bdf5baf9671cd91e7c0041ddefb/4d4a2/techletter.app-screenshot-1573060439503.png 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4ab78bdf5baf9671cd91e7c0041ddefb/4d4a2/techletter.app-screenshot-1573060439503.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Dunno about you, but I'm tired of writing that code. Fingers crossed we get some amazing new libraries around Suspense. 🤞`}</p>
    <p>{`While we wait, here's some concurrent mode stuff you `}<em parentName="p">{`can`}</em>{` do right now.`}</p>
    <h2 {...{
      "id": "trying-concurrent-mode-yourself"
    }}>{`Trying concurrent mode yourself`}</h2>
    <p>{`The easiest way to try concurrent mode is to fire up a CodeSandbox and choose React's experimental channel.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/01a16213d67183a2d05900dfcd94b0bb/2e367/mg9OLOa.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.81165919282511%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'215\\'%20viewBox=\\'0%200%20400%20215\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2010c0%208%200%209%202%209%204%200%205%203%205%2011S6%2040%202%2040H0v32h2c4%200%205%203%205%2011%200%207-1%2010-5%2010-2%200-2%201-2%2061v61h44v-3c0-3%200-3%201-1v3l4%201c3%200%203%200%203-2v-3l1%202c0%202%201%203%202%203l1-3%201-2v3l1%202%202-2h1c0%202%202%202%2018%202h19v-3l1-3v3c0%203%202%204%202%201h1c0%203%203%203%203%200h1c0%203%2020%203%2020%200h1c0%203%203%203%203%200h1c0%202%201%202%204%202%205%200%205%200%205-24v-19H90c-43%200-49%200-50-2-3-2-3-21%200-23%201-2%207-2%2050-2h50V82c0-61%200-64-2-63s-4%200-4-1h2l2-1-3-1c-1%200-1-3%201-4l2%201v1c-3-1-3%200%200%202l2%201V0H0v10m354%2098v107h46v-16l-1-17v-27c1%201%201-7%201-34a1391%201391%200%2001-1-44l-1-2v-1l1-3V56l-1-2h1l1-10-1-10-1-3%201-3v3c0%202%200%202%201%200V0h-46v108\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/01a16213d67183a2d05900dfcd94b0bb/ca0a1/mg9OLOa.webp 223w", "/static/01a16213d67183a2d05900dfcd94b0bb/75680/mg9OLOa.webp 445w", "/static/01a16213d67183a2d05900dfcd94b0bb/8d1ba/mg9OLOa.webp 890w", "/static/01a16213d67183a2d05900dfcd94b0bb/fbb05/mg9OLOa.webp 1066w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/01a16213d67183a2d05900dfcd94b0bb/e92b6/mg9OLOa.png 223w", "/static/01a16213d67183a2d05900dfcd94b0bb/e66bf/mg9OLOa.png 445w", "/static/01a16213d67183a2d05900dfcd94b0bb/4ef49/mg9OLOa.png 890w", "/static/01a16213d67183a2d05900dfcd94b0bb/2e367/mg9OLOa.png 1066w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/01a16213d67183a2d05900dfcd94b0bb/4ef49/mg9OLOa.png",
              "alt": "mg9OLOa",
              "title": "mg9OLOa",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Same thing works in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`. Please don't use it in production yet. Experiment and play only. There's bugs to fix and features to come :)`}</p>
    <p>{`We played around on a recent livestream and created a couple tiny examples using React Suspense's new fetch-as-you-render ability.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=NngI9tZz48E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20102v88l3-1%204-1%203-1-3-1-3-2-1-3v-4l2-3c-2-2%202-12%204-12h14l-1%2028-2-1c-2-1-4-1-4%201l1%201c3%200%204%202%203%208-1%207-2%207-8%206-3%200-5-1-8-4l-4-3v27h401v-14c0-8%200-13-1-11%200%202-1%203-3%203l-2-1-21-1-21-1h42v-11l-22-1h-22v7c0%206%200%206-3%208h-28l-25%201-1%205-1%205-1-1v-10h-53v-34H113v8l-19%203-22%205c-7%201-5-4%202-6l6-1-4-1c-5-1%209-4%2018-3l7-1c-1-1-9-2-14-1-14%203-20%204-22%202-2-1-2-2-1-2v-1l-2-1h-1l2-2c2%200%202%200%201-1v-2l-1-2c-1-1%202-1%209-1l25-1h15v2l1%203h129v-6H126V38h116V15H136L15%2014H0v88m195%203c-5%200-6%202-6%208%200%204%200%205%202%206h18v-13c-2-1-11-2-14-1m156%2047v3h44v-6h-44v3m0%2020v15h44v-10l-1-11v-1l1-5v-4h-44v16m-299-1c-7%201-13%208-10%2011l2%202h4c6-1%2011%207%207%2011v1h3l1%201c2-1%204%204%204%207l-4%201c-2%200-3%200-2%201l3%201c4%200%202%203-3%203-2%200-2%200%200%201%207%203%209-2%209-16%201-11-1-13-5-8l-3%201c0-1%204-6%206-5%202%200%201-3-1-7-3-4-7-6-11-5m61%2022c0%2012%200%2014%202%2014l1%201%204%201%205%201c2%201%202%200%202-12v-12l-6-3-7-3-1%2013\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c08c268c102e351439b2fef5950d62d2/ca0a1/techletter.app-screenshot-1573060457596.webp 223w", "/static/c08c268c102e351439b2fef5950d62d2/75680/techletter.app-screenshot-1573060457596.webp 445w", "/static/c08c268c102e351439b2fef5950d62d2/0ba47/techletter.app-screenshot-1573060457596.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c08c268c102e351439b2fef5950d62d2/e92b6/techletter.app-screenshot-1573060457596.png 223w", "/static/c08c268c102e351439b2fef5950d62d2/e66bf/techletter.app-screenshot-1573060457596.png 445w", "/static/c08c268c102e351439b2fef5950d62d2/6af66/techletter.app-screenshot-1573060457596.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c08c268c102e351439b2fef5950d62d2/6af66/techletter.app-screenshot-1573060457596.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Our context is a D3 scatterplot because a) it looks pretty and b) `}<a parentName="p" {...{
        "href": "https://reactfordataviz.com"
      }}>{`reactfordataviz.com`}</a>{` 😛`}</p>
    <p>{`Don't worry, if you're not into dataviz. The same core concepts apply.`}</p>
    <p>{`We created a fake data streaming API, rendered each unit of data with the new `}<inlineCode parentName="p">{`<Suspense />`}</inlineCode>{` component, and let React handle the rest. Works great.`}</p>
    <p>{`Try it out here 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/festive-lake-62r14"
      }}>{`CodeSandbox 1`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/dark-waterfall-uzlzb"
      }}>{`CodeSandbox 2`}</a></p>
    <h3 {...{
      "id": "a-fake-streaming-data-api"
    }}>{`A fake streaming data API`}</h3>
    <p>{`We split our fake API into two endpoints:`}</p>
    <ul>
      <li parentName="ul">{`fetch a total count`}</li>
      <li parentName="ul">{`fetch datapoints one by one until done`}</li>
    </ul>
    <p>{`A real world API analog would be an API that deals with large data. First you make a request for some meta data (counts, dates, ranges, etc), then page through the large dataset.`}</p>
    <p>{`For simplicity and stress testing, we fetch each item individually. Timeouts simulate `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` calls.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20Pretennds%20to%20fetch%20meta%20data%2C%20our%20total%20count%0Afunction%20fetchCount()%20%7B%0A%20%20console.log(%22fetching%20count%20...%22)%3B%0A%20%20return%20new%20Promise(resolve%20%3D%3E%20%7B%0A%09%20%20%2F%2F%20this%20would%20be%20a%20fetch()%20in%20nreal%20life%0A%20%20%20%20setTimeout(()%20%3D%3E%20%7B%0A%20%20%20%20%20%20console.log(%22fetched%20count%22)%3B%0A%20%20%20%20%20%20resolve(10000)%3B%0A%20%20%20%20%7D%2C%201000)%3B%0A%20%20%7D)%3B%0A%7D%0A%0A%2F%2F%20Here%20we%20have%20a%20set%20of%20requests%20that%20depend%0A%2F%2F%20on%20data%20from%20initial%20request%0A%2F%2F%20which%20is%20kinda%20messy%20but%20realistic%0A%0A%2F%2F%20fetchItems%20sets%20out%20to%20fetch%20every%20item%0Afunction%20fetchItems(countPromise)%20%7B%0A%20%20console.log(%22fetching%20items%20...%22)%3B%0A%20%20return%20new%20Promise(resolve%20%3D%3E%20%7B%0A%09%20%20%2F%2F%20start%20by%20waiting%20for%20meta%20data%0A%20%20%20%20countPromise.then(count%20%3D%3E%20%7B%0A%20%20%20%20%20%20resolve(%0A%09%20%20%20%20%20%20%2F%2F%20map%20through%20a%20count-sized%20empty%20array%20%0A%09%20%20%20%20%20%20%2F%2F%20create%20promises%0A%20%20%20%20%20%20%20%20new%20Array(count).fill(null).map((_%2C%20i)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%2F%2F%20create%20a%20promise%20for%20each%20individual%20item%20request%0A%20%20%20%20%20%20%20%20%20%20return%20wrapPromise(fetchItem(i))%3B%0A%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20)%3B%0A%20%20%20%20%7D)%3B%0A%20%20%7D)%3B%0A%7D%0A%0A%2F%2F%20fetches%20an%20individual%20item%20at%20%60index%60%0Afunction%20fetchItem(index)%20%7B%0A%20%20return%20new%20Promise(resolve%20%3D%3E%20%7B%0A%09%20%20%2F%2F%20this%20would%20be%20a%20fetch()%20in%20real%20life%0A%20%20%20%20setTimeout(()%20%3D%3E%20%7B%0A%09%20%20%20%20%2F%2F%20each%20datapoint%20is%20a%20random%20%7B%20x%2C%20y%20%7D%20object%0A%09%20%20%20%20%2F%2F%20could%20be%20anything%20in%20real%20life%0A%20%20%20%20%20%20resolve(%7B%0A%20%20%20%20%20%20%20%20x%3A%20Math.random()%2C%0A%20%20%20%20%20%20%20%20y%3A%20Math.random()%0A%20%20%20%20%20%20%7D)%3B%0A%09%09%20%20%2F%2F%20promise%20resolves%20at%20a%20random%20timeout%0A%09%09%20%20%2F%2F%20this%20creates%20a%20nicer%20effect%20and%20better%20tests%20Suspense%20%3A)%0A%20%20%20%20%7D%2C%20Math.random()%20*%201000)%3B%0A%20%20%7D)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "654px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "163.67713004484304%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'654\\'%20viewBox=\\'0%200%20400%20654\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2030c-2%201-3%20590-1%20594%203%203%20357%203%20360%200%202-4%201-593-1-594H21\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/53d5f4ca42c33460614e03d32faab7c0/ca0a1/techletter.app-screenshot-1573060439854.webp 223w", "/static/53d5f4ca42c33460614e03d32faab7c0/75680/techletter.app-screenshot-1573060439854.webp 445w", "/static/53d5f4ca42c33460614e03d32faab7c0/d7085/techletter.app-screenshot-1573060439854.webp 654w"],
                "sizes": "(max-width: 654px) 100vw, 654px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/53d5f4ca42c33460614e03d32faab7c0/e92b6/techletter.app-screenshot-1573060439854.png 223w", "/static/53d5f4ca42c33460614e03d32faab7c0/e66bf/techletter.app-screenshot-1573060439854.png 445w", "/static/53d5f4ca42c33460614e03d32faab7c0/68e9c/techletter.app-screenshot-1573060439854.png 654w"],
                "sizes": "(max-width: 654px) 100vw, 654px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/53d5f4ca42c33460614e03d32faab7c0/68e9c/techletter.app-screenshot-1573060439854.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h3 {...{
      "id": "an-api-that-understands"
    }}>{`An API that understands`}</h3>
    <p>{`Those function calls simulate API requests. We have to wrap them in a way that `}<inlineCode parentName="p">{`<Suspense>`}</inlineCode>{` understands.`}</p>
    <p>{`I borrowed the promise wrapper that Dan Abramov uses in `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/concurrent-mode-suspense.html"
      }}>{`official docs on Suspense`}</a>{`. You'd build something more robust for real life use. Or, if you're like me, wait for libraries to show up. 😇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20This%20is%20our%20top%20level%20function%20for%20data%20fetching%0A%2F%2F%20We'll%20use%20this%20to%20fetch%20data%20as%20we%20render%20the%20page%0Aexport%20function%20fetchData()%20%7B%0A%20%20let%20countPromise%20%3D%20fetchCount()%3B%0A%20%20let%20itemsPromise%20%3D%20fetchItems(countPromise)%3B%0A%0A%20%20return%20%7B%0A%20%20%20%20count%3A%20wrapPromise(countPromise)%2C%0A%20%20%20%20items%3A%20wrapPromise(itemsPromise)%0A%20%20%7D%3B%0A%7D%0A%0A%2F%2F%20Suspense%20integrations%20like%20Relay%20implement%0A%2F%2F%20a%20contract%20like%20this%20to%20integrate%20with%20React.%0A%2F%2F%20Real%20implementations%20can%20be%20significantly%20more%20complex.%0A%2F%2F%20Don't%20copy-paste%20this%20into%20your%20project!%0Afunction%20wrapPromise(promise)%20%7B%0A%20%20let%20status%20%3D%20%22pending%22%3B%0A%20%20let%20result%3B%0A%20%20let%20suspender%20%3D%20promise.then(%0A%20%20%20%20r%20%3D%3E%20%7B%0A%20%20%20%20%20%20status%20%3D%20%22success%22%3B%0A%20%20%20%20%20%20result%20%3D%20r%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20e%20%3D%3E%20%7B%0A%20%20%20%20%20%20status%20%3D%20%22error%22%3B%0A%20%20%20%20%20%20result%20%3D%20e%3B%0A%20%20%20%20%7D%0A%20%20)%3B%0A%20%20return%20%7B%0A%20%20%20%20read()%20%7B%0A%20%20%20%20%20%20if%20(status%20%3D%3D%3D%20%22pending%22)%20%7B%0A%20%20%20%20%20%20%20%20throw%20suspender%3B%0A%20%20%20%20%20%20%7D%20else%20if%20(status%20%3D%3D%3D%20%22error%22)%20%7B%0A%20%20%20%20%20%20%20%20throw%20result%3B%0A%20%20%20%20%20%20%7D%20else%20if%20(status%20%3D%3D%3D%20%22success%22)%20%7B%0A%20%20%20%20%20%20%20%20return%20result%3B%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%20%20%7D%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "566px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "160.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'641\\'%20viewBox=\\'0%200%20400%20641\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2036a28896%2028896%200%20001%20571h352c2-1%203-493%201-546V35l-177-1C33%2034%2024%2034%2023%2036\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea2c68b370e674f1d2a76b52e0e9ffc0/ca0a1/techletter.app-screenshot-1573060439294.webp 223w", "/static/ea2c68b370e674f1d2a76b52e0e9ffc0/75680/techletter.app-screenshot-1573060439294.webp 445w", "/static/ea2c68b370e674f1d2a76b52e0e9ffc0/3161c/techletter.app-screenshot-1573060439294.webp 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea2c68b370e674f1d2a76b52e0e9ffc0/e92b6/techletter.app-screenshot-1573060439294.png 223w", "/static/ea2c68b370e674f1d2a76b52e0e9ffc0/e66bf/techletter.app-screenshot-1573060439294.png 445w", "/static/ea2c68b370e674f1d2a76b52e0e9ffc0/6fe44/techletter.app-screenshot-1573060439294.png 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ea2c68b370e674f1d2a76b52e0e9ffc0/6fe44/techletter.app-screenshot-1573060439294.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The idea behind `}<inlineCode parentName="p">{`wrapPromise`}</inlineCode>{` is to create a uniform interface for Suspense to hook into your promise. This way it can tell whether it's still waiting, there was an error, or you're ready to render.`}</p>
    <p>{`I imagine this makes it easier to integrate with a variety of data fetching mechanisms. Wrapper makes them conform to Suspense's API.`}</p>
    <h2 {...{
      "id": "render-as-you-fetch"
    }}>{`Render-as-you-fetch`}</h2>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/festive-lake-62r14"
      }}><img parentName="a" {...{
          "src": "/3fe9f2b1d1fa2563952153c60480f292/sh998Lm.gif",
          "alt": null
        }}></img></a></p>
    <p>{`Once we've got the API wrappers set up, we can render our React app in parallel with fetching the data. In some cases even in parallel with fetching the code itself. (code splitting)`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20%7B%20fetchData%20%7D%20from%20%22.%2FfakeApi%22%3B%0A%0Aconst%20resource%20%3D%20fetchData()%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "406px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.7085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'220\\'%20viewBox=\\'0%200%20400%20220\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%2049l-2%202v60l1%2062c3%202%20331%202%20334%200%201-2%202-4%202-62V51l-3-2c-4-3-328-3-332%200m34%2015l-2%204%202%204c4%204%2010%201%2010-4%200-2-4-6-7-6l-3%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/726813a3faf3101432b8be291855a223/ca0a1/techletter.app-screenshot-1573060439160.webp 223w", "/static/726813a3faf3101432b8be291855a223/09a6f/techletter.app-screenshot-1573060439160.webp 406w"],
                "sizes": "(max-width: 406px) 100vw, 406px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/726813a3faf3101432b8be291855a223/e92b6/techletter.app-screenshot-1573060439160.png 223w", "/static/726813a3faf3101432b8be291855a223/e33ef/techletter.app-screenshot-1573060439160.png 406w"],
                "sizes": "(max-width: 406px) 100vw, 406px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/726813a3faf3101432b8be291855a223/e33ef/techletter.app-screenshot-1573060439160.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We start the request at top level, `}<em parentName="p">{`not`}</em>{` inside an effect. This way it starts as soon as the file loads.`}</p>
    <p>{`Presumably that's just before you're ready to render. The approach won't work if you're loading 500 pages all in a single bundle and only 1 of them is visible.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Top-level fetching assumes your router handles code splitting and loads only the files it needs.`}</p>
    </blockquote>
    <p>{`To render our data without UI glitching, we use the `}<inlineCode parentName="p">{`<Suspense>`}</inlineCode>{` component ✌️`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20App()%20%7B%0A%20%20return%20(%0A%20%20%20%20%3Cdiv%20className%3D%22App%22%3E%0A%20%20%20%20%20%20%2F%2F%20...%0A%20%20%20%20%20%20%0A%20%20%20%20%20%20%2F%2F%20show%20a%20Loading%20...%20state%20while%20the%20first%20request%20finishes%0A%20%20%20%20%20%20%3CSuspense%20fallback%3D%7B%3Ch2%3ELoading%20...%3C%2Fh2%3E%7D%3E%0A%20%20%20%20%20%20%20%20%3CDataList%20%2F%3E%0A%20%20%20%20%20%20%3C%2FSuspense%3E%0A%20%20%20%20%3C%2Fdiv%3E%0A%20%20)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "630px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'244\\'%20viewBox=\\'0%200%20400%20244\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2032c-2%203-1%20180%201%20181%202%203%20354%203%20356%200%202-1%203-178%201-181S23%2029%2021%2032\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/59cc8405585cb34f9ea464f9f446833f/ca0a1/techletter.app-screenshot-1573060439786.webp 223w", "/static/59cc8405585cb34f9ea464f9f446833f/75680/techletter.app-screenshot-1573060439786.webp 445w", "/static/59cc8405585cb34f9ea464f9f446833f/8aab1/techletter.app-screenshot-1573060439786.webp 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/59cc8405585cb34f9ea464f9f446833f/e92b6/techletter.app-screenshot-1573060439786.png 223w", "/static/59cc8405585cb34f9ea464f9f446833f/e66bf/techletter.app-screenshot-1573060439786.png 445w", "/static/59cc8405585cb34f9ea464f9f446833f/f058b/techletter.app-screenshot-1573060439786.png 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/59cc8405585cb34f9ea464f9f446833f/f058b/techletter.app-screenshot-1573060439786.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We wrap everything in Suspense to show a loading state while we fetch meta data. The `}<inlineCode parentName="p">{`count`}</inlineCode>{` in our case.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<DataList>`}</inlineCode>{` component itself tries to read from our API and render what it gets.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20DataList%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20count%20%3D%20resource.count.read()%3B%0A%0A%20%20return%20(%0A%20%20%20%20%3Csvg%20width%3D%22300%22%20height%3D%22300%22%3E%0A%20%20%20%20%20%20%7Bnew%20Array(count).fill(null).map((d%2C%20i)%20%3D%3E%20(%0A%20%20%20%20%20%20%20%20%3CSuspense%20fallback%3D%7Bnull%7D%20key%3D%7Bi%7D%3E%0A%20%20%20%20%20%20%20%20%20%20%3CDataItem%20index%3D%7Bi%7D%20%2F%3E%0A%20%20%20%20%20%20%20%20%3C%2FSuspense%3E%0A%20%20%20%20%20%20))%7D%0A%20%20%20%20%3C%2Fsvg%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "502px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "80.26905829596413%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'321\\'%20viewBox=\\'0%200%20400%20321\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-1%201-2%2021-2%20121%200%20119%200%20119%202%20121%203%203%20343%203%20346%200%202-2%202-2%202-121%200-100-1-120-2-121-1-2-14-2-173-2S28%2038%2027%2040\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9ca0417eb4d6092c1e6333163b232c5a/ca0a1/techletter.app-screenshot-1573060438531.webp 223w", "/static/9ca0417eb4d6092c1e6333163b232c5a/75680/techletter.app-screenshot-1573060438531.webp 445w", "/static/9ca0417eb4d6092c1e6333163b232c5a/20682/techletter.app-screenshot-1573060438531.webp 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9ca0417eb4d6092c1e6333163b232c5a/e92b6/techletter.app-screenshot-1573060438531.png 223w", "/static/9ca0417eb4d6092c1e6333163b232c5a/e66bf/techletter.app-screenshot-1573060438531.png 445w", "/static/9ca0417eb4d6092c1e6333163b232c5a/eea79/techletter.app-screenshot-1573060438531.png 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9ca0417eb4d6092c1e6333163b232c5a/eea79/techletter.app-screenshot-1573060438531.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This is important and very easy to get wrong. `}<em parentName="p">{`Suspense goes `}<strong parentName="em">{`around`}</strong>{` the component that's reading data`}</em>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/dan_abramov/status/1191390129795063810"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.15695067264574%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'221\\'%20viewBox=\\'0%200%20400%20221\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%209c-9%206-9%2019-1%2025%2013%209%2029-6%2022-19-4-8-14-10-21-6m60%20153c-4%203-4%208-1%208%202%200%202%200%201%201-3%200%200%204%204%204%202%200%202%200%201-1h4v-3c1-2%200-3-3%200h-3v-5l2-1%202-2c2%200%202%200%200-2s-4-1-7%201m72%201c-3%202-3%204-3%206%202%207%209%209%2014%204%203-4%203-7-1-10-4-4-6-4-10%200m-85-1l-4%202c-6%201-5%2010%201%2011%208%202%2012-7%206-13h-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/097d147f7277808e6bad8da8c52b4fcb/ca0a1/techletter.app-screenshot-1573060437461.webp 223w", "/static/097d147f7277808e6bad8da8c52b4fcb/75680/techletter.app-screenshot-1573060437461.webp 445w", "/static/097d147f7277808e6bad8da8c52b4fcb/0ba47/techletter.app-screenshot-1573060437461.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/097d147f7277808e6bad8da8c52b4fcb/e92b6/techletter.app-screenshot-1573060437461.png 223w", "/static/097d147f7277808e6bad8da8c52b4fcb/e66bf/techletter.app-screenshot-1573060437461.png 445w", "/static/097d147f7277808e6bad8da8c52b4fcb/6af66/techletter.app-screenshot-1573060437461.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/097d147f7277808e6bad8da8c52b4fcb/6af66/techletter.app-screenshot-1573060437461.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Yeah, happened the very first time I tried to build with React Suspense without following the docs. You get that experiment in your inbox next week, it's super neat.`}</p>
    <p>{`Now here's where it gets real fun: You can nest suspended components.`}</p>
    <p>{`Notice how we're wrapping each `}<inlineCode parentName="p">{`<DataItem>`}</inlineCode>{` in its own suspense?`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20%20%20%7Bnew%20Array(count).fill(null).map((d%2C%20i)%20%3D%3E%20(%0A%20%20%20%20%20%20%20%20%3CSuspense%20fallback%3D%7Bnull%7D%20key%3D%7Bi%7D%3E%0A%20%20%20%20%20%20%20%20%20%20%3CDataItem%20index%3D%7Bi%7D%20%2F%3E%0A%20%20%20%20%20%20%20%20%3C%2FSuspense%3E%0A%20%20%20%20%20%20))%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "502px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.569506726457405%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'206\\'%20viewBox=\\'0%200%20400%20206\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-2%202-3%20123-1%20127l2%202h344l2-2c2-4%201-125-1-127-2-3-344-3-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1ba2a1b54c49f8954bec7b574923a750/ca0a1/techletter.app-screenshot-1573060439225.webp 223w", "/static/1ba2a1b54c49f8954bec7b574923a750/75680/techletter.app-screenshot-1573060439225.webp 445w", "/static/1ba2a1b54c49f8954bec7b574923a750/20682/techletter.app-screenshot-1573060439225.webp 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1ba2a1b54c49f8954bec7b574923a750/e92b6/techletter.app-screenshot-1573060439225.png 223w", "/static/1ba2a1b54c49f8954bec7b574923a750/e66bf/techletter.app-screenshot-1573060439225.png 445w", "/static/1ba2a1b54c49f8954bec7b574923a750/eea79/techletter.app-screenshot-1573060439225.png 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1ba2a1b54c49f8954bec7b574923a750/eea79/techletter.app-screenshot-1573060439225.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That's because each item is in charge of its own API fetching. Seems kinda bonkers, but this new approach (also popular in GraphQL circles) is really powerful.`}</p>
    <p>{`Each React component should take care of its own data fetching. The times when you had a central authority take care of all data are behind us. Edge computing is now. Even if just in our UI tree. 🦾`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20DataItem%20%3D%20(%7B%20index%20%7D)%20%3D%3E%20%7B%0A%20%20const%20item%20%3D%20resource.items.read()%5Bindex%5D.read()%3B%0A%20%20%2F%2F%20We%20know%20Math.random()%20generates%20in%20%5B0%2C%201%5D%0A%20%20const%20xScale%20%3D%20d3%0A%20%20%20%20.scaleLinear()%0A%20%20%20%20.domain(%5B0%2C%201%5D)%0A%20%20%20%20.range(%5B0%2C%20300%5D)%3B%0A%20%20const%20yScale%20%3D%20d3%0A%20%20%20%20.scaleLinear()%0A%20%20%20%20.domain(%5B0%2C%201%5D)%0A%20%20%20%20.range(%5B0%2C%20300%5D)%3B%0A%0A%20%20return%20(%0A%20%20%20%20%3Ccircle%0A%20%20%20%20%20%20cx%3D%7BxScale(item.x)%7D%0A%20%20%20%20%20%20cy%3D%7ByScale(item.y)%7D%0A%20%20%20%20%20%20r%3D%7B4%7D%0A%20%20%20%20%20%20fill%3D%22%23f87%22%0A%20%20%20%20%20%20fillOpacity%3D%220.3%22%0A%20%20%20%20%2F%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "510px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "110.76233183856503%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'443\\'%20viewBox=\\'0%200%20400%20443\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2039c-2%202-1%20364%201%20366s344%202%20346%200%203-364%201-366-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/957ed89a8cc9e75f00d8841749dd91a3/ca0a1/techletter.app-screenshot-1573060439084.webp 223w", "/static/957ed89a8cc9e75f00d8841749dd91a3/75680/techletter.app-screenshot-1573060439084.webp 445w", "/static/957ed89a8cc9e75f00d8841749dd91a3/b7235/techletter.app-screenshot-1573060439084.webp 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/957ed89a8cc9e75f00d8841749dd91a3/e92b6/techletter.app-screenshot-1573060439084.png 223w", "/static/957ed89a8cc9e75f00d8841749dd91a3/e66bf/techletter.app-screenshot-1573060439084.png 445w", "/static/957ed89a8cc9e75f00d8841749dd91a3/0abdd/techletter.app-screenshot-1573060439084.png 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/957ed89a8cc9e75f00d8841749dd91a3/0abdd/techletter.app-screenshot-1573060439084.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Each item hooks into its own `}<inlineCode parentName="p">{`index`}</inlineCode>{`'d API promise that we created in `}<inlineCode parentName="p">{`fetchItem`}</inlineCode>{` earlier.`}</p>
    <p><inlineCode parentName="p">{`items.read()`}</inlineCode>{` returns an array of wrapped promises. `}<inlineCode parentName="p">{`[index]`}</inlineCode>{` gets the one for `}<em parentName="p">{`this`}</em>{` item. `}<inlineCode parentName="p">{`.read()`}</inlineCode>{` waits for that promise to return some data.`}</p>
    <p>{`The surrounding `}<inlineCode parentName="p">{`<Suspense>`}</inlineCode>{` component handles suspending and fallback renders while this component waits for data to show up. Once data shows up, Suspense renders `}<inlineCode parentName="p">{`<DataItem>`}</inlineCode>{` which uses a little D3 magic to translate `}<inlineCode parentName="p">{`[0, 1]`}</inlineCode>{` numbers to a bigger scale and renders an SVG circle.`}</p>
    <p><img parentName="p" {...{
        "src": "/8ea40ab6c639c0257ed3d7ee0f1d47e6/media-26ufdipQqU2lhNA4g-giphy.gif",
        "alt": "mind_blown giphy"
      }}></img></p>
    <h3 {...{
      "id": "streaming-in-batches"
    }}>{`Streaming in batches`}</h3>
    <p>{`Now of course reading data one by one like that is slow.`}</p>
    <p>{`Instead, you can use a paging approach and load a many data points at once. 100 worked pretty well with our fake API.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/dark-waterfall-uzlzb"
      }}><img parentName="a" {...{
          "src": "/34eab03e89ebccbfd5f8cf3c7907291f/FznpjtC.gif",
          "alt": null
        }}></img></a></p>
    <p>{`Rendering code looks the same, just gets an extra loop.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20DataItem%20%3D%20(%7B%20index%20%7D)%20%3D%3E%20%7B%0A%20%20const%20batch%20%3D%20resource.items.read()%5Bindex%5D.read()%3B%0A%20%20%2F%2F%20...%0A%0A%20%20return%20batch.map(item%20%3D%3E%20(%0A%20%20%20%20%2F%2F%20render%20circle%0A%20%20))%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "518px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'242\\'%20viewBox=\\'0%200%20400%20242\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2038l-1%2084c0%2080%200%2082%202%2083h346c2-1%202-3%202-83l-1-84c-2-2-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/da96be04808eaa1fa6ea21b658e81187/ca0a1/techletter.app-screenshot-1573060439371.webp 223w", "/static/da96be04808eaa1fa6ea21b658e81187/75680/techletter.app-screenshot-1573060439371.webp 445w", "/static/da96be04808eaa1fa6ea21b658e81187/c29d2/techletter.app-screenshot-1573060439371.webp 518w"],
                "sizes": "(max-width: 518px) 100vw, 518px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/da96be04808eaa1fa6ea21b658e81187/e92b6/techletter.app-screenshot-1573060439371.png 223w", "/static/da96be04808eaa1fa6ea21b658e81187/e66bf/techletter.app-screenshot-1573060439371.png 445w", "/static/da96be04808eaa1fa6ea21b658e81187/6b9fd/techletter.app-screenshot-1573060439371.png 518w"],
                "sizes": "(max-width: 518px) 100vw, 518px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/da96be04808eaa1fa6ea21b658e81187/6b9fd/techletter.app-screenshot-1573060439371.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And we changed the fake API to return multiple datapoints per batch.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20fetchItems(countPromise)%20%7B%0A%20%20console.log(%22fetching%20items%20...%22)%3B%0A%20%20return%20new%20Promise(resolve%20%3D%3E%20%7B%0A%20%20%20%20countPromise.then(count%20%3D%3E%20%7B%0A%20%20%20%20%20%20resolve(%0A%09%20%20%20%20%20%20%2F%2F%20a%20promise%20for%20every%20100th%20element%20of%20%22count%22%0A%20%20%20%20%20%20%20%20new%20Array(count%20%2F%20100).fill(null).map((_%2C%20i)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%2F%2F%20create%20a%20promise%20for%20each%20individual%20batch%20request%0A%20%20%20%20%20%20%20%20%20%20return%20wrapPromise(fetchBatch(i))%3B%0A%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20)%3B%0A%20%20%20%20%7D)%3B%0A%20%20%7D)%3B%0A%7D%0A%0Afunction%20fetchBatch(index)%20%7B%0A%20%20return%20new%20Promise(resolve%20%3D%3E%20%7B%0A%20%20%20%20%2F%2F%20IRL%20this%20setTimeout%20would%20be%20a%20fetch()%0A%20%20%20%20setTimeout(()%20%3D%3E%20%7B%0A%20%20%20%20%20%20resolve(%0A%09%20%20%20%20%20%20%2F%2F%20return%20100%20datapoints%20per%20fetch%0A%20%20%20%20%20%20%20%20new%20Array(100).fill(null).map(i%20%3D%3E%20(%7B%0A%20%20%20%20%20%20%20%20%20%20x%3A%20Math.random()%2C%0A%20%20%20%20%20%20%20%20%20%20y%3A%20Math.random()%0A%20%20%20%20%20%20%20%20%7D))%0A%20%20%20%20%20%20)%3B%0A%20%20%20%20%7D%2C%20Math.random()%20*%201000)%3B%0A%20%20%7D)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "606px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "113.90134529147981%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'456\\'%20viewBox=\\'0%200%20400%20456\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2034a16045%2016045%200%20001%20390c2%202%20352%202%20354%200%202-1%202-16%202-195l-1-195c-1-3-355-3-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/94058849f9267d02eb1edd4d35fee8dc/ca0a1/techletter.app-screenshot-1573060439443.webp 223w", "/static/94058849f9267d02eb1edd4d35fee8dc/75680/techletter.app-screenshot-1573060439443.webp 445w", "/static/94058849f9267d02eb1edd4d35fee8dc/18e7e/techletter.app-screenshot-1573060439443.webp 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/94058849f9267d02eb1edd4d35fee8dc/e92b6/techletter.app-screenshot-1573060439443.png 223w", "/static/94058849f9267d02eb1edd4d35fee8dc/e66bf/techletter.app-screenshot-1573060439443.png 445w", "/static/94058849f9267d02eb1edd4d35fee8dc/4d4a2/techletter.app-screenshot-1573060439443.png 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/94058849f9267d02eb1edd4d35fee8dc/4d4a2/techletter.app-screenshot-1573060439443.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p>{`I encourage you to give React Suspense and concurrent mode in general a try. It's pretty great, almost ready for the real world, and it might make you rethink how you structure your apps.`}</p>
    <p>{`Encouraging you to push data loading into the edges of your component tree seems like a particularly powerful pattern. `}<strong parentName="p">{`Load data as close to where you're using it as possible.`}</strong></p>
    <p>{`Enjoy ❤️`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      